import "./PipeProblems.module.css";
import Header from "@/reusable_sections/Header";
import PipeProblems from "./sections/PipeProblems";
import ServiceContact from "./sections/ServiceContact";
import Footer from "@/reusable_sections/Footer";
export default function PipeProblemsPage() {
  return <div>
      <Header />
      <PipeProblems />
      <ServiceContact />
      <Footer />
    </div>;
}